import styled from 'styled-components';
import { Button, IconButton, TextField, Typography } from '@web-chat-core/ui-kit';

export const SIPCallLayout = styled.div`
    background: ${(props) => props.theme.root.colors.background['01Base']};
    padding: 16px;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
`;

export const Header = styled(Typography)`
    display: block;
    margin-bottom: 12px;
`;

export const KeypadButton = styled(Button)`
    background: ${(props) => props.theme.root.colors.basicColors['6%']};
    border-radius: 12px;
    padding: 0;
    height: 52px;
    width: 52px;
    flex-shrink: 0;
    display: flex;
    place-content: center;

    &:hover,
    &:focus,
    &:active {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }
`;

export const SIPCallContainer = styled.div`
    display: flex;
    gap: 12px;
`;

export const PhoneTextField = styled(TextField)`
    flex-grow: 1;
`;

export const PhoneCallButton = styled(Button)`
    display: flex;
    place-content: center;
    border-radius: 12px;
    height: 52px;
    width: 52px;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;
